import React from 'react';
import { Catcher, CustomStatusButton } from '../';
import cx from 'classnames';
import { IChangeStatusCommands } from '../../interfaces';
import { ITrNotificationMessage } from '../../translate';
import Styles from '../styles/m_itemCardStyles.less';

type IChangeStatusToolBar = {
    changeStatus: (status: IChangeStatusCommands) => void;
    disabled?: boolean;
    disabledHint?: ITrNotificationMessage;
    loading?: boolean;
    onCancel?: () => void;
    statuses: IChangeStatusCommands[];
};

export const ChangeStatusToolBar: React.FC<IChangeStatusToolBar> = ({
    changeStatus,
    disabled,
    disabledHint,
    loading,
    onCancel,
    statuses,
}: IChangeStatusToolBar) => {
    const buttons = statuses.map((status: IChangeStatusCommands) => (
        <CustomStatusButton
            key={status}
            disabled={disabled}
            disabledHint={disabledHint}
            loading={loading}
            onClick={(): void => changeStatus(status)}
            status={status}
        />
    ));

    return (
        <Catcher>
            <div className={cx(Styles.cardToolBar, Styles.statusToolBar)}>
                {buttons}
                {onCancel ? <CustomStatusButton disabled={disabled} status={'cancel'} onClick={onCancel} /> : null}
            </div>
        </Catcher>
    );
};
